<div app-modal-content class="flex w-[90vw] flex-col gap-10 lg:w-[75rem]">
  <div class="flex gap-2">
    <svg-icon
      src="assets/icons/icon-alert-fill.svg"
      class="flex h-20 w-20 self-start text-base-status-warning"
    ></svg-icon>
    {{ 'eclass.aula.alerta-existente' | translate }}
  </div>

  <div class="max-h-[50vh] overflow-auto">
    <table app-table>
      <thead>
        <tr>
          <th app-table-cell translate>geral.unidade-escolar</th>
          <th app-table-cell translate>geral.turma</th>
          <th app-table-cell translate>eclass.disciplina</th>
          <th app-table-cell translate>geral.data</th>
        </tr>
      </thead>
      <tbody app-table-body>
        <tr *ngFor="let item of data">
          <td app-table-cell class="truncate">{{ item.entity.description }}</td>
          <td app-table-cell class="w-80 truncate text-center">{{ item.group.description }}</td>
          <td app-table-cell class="w-80 truncate text-center">{{ item.subject.description }}</td>
          <td app-table-cell class="w-40 text-end">{{ item.date | dateTranslate }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <span class="text-end font-semibold text-gray-700" translate> geral.confirmacao </span>
</div>

<div app-modal-footer class="justify-end gap-2">
  <button
    app-button
    type="button"
    class="mr-2 bg-base-status-success px-5 font-semibold uppercase text-white"
    [dialogClose]="true"
  >
    {{ 'geral.sim' | translate }}
  </button>
  <button
    app-outline-button
    type="button"
    class="border-none px-2 font-semibold uppercase text-red-500 hover:[&:not([disabled])]:bg-red-500 hover:[&:not([disabled])]:text-white"
    dialogClose
  >
    {{ 'geral.nao' | translate }}
  </button>
</div>
